import { AppBar, Grid2 as Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import CenterLinks from './CenterLinks';
import LogoAddress from './LogoAddress';

const Footer: React.FC = () => {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <AppBar
            position='sticky'
            color='default'
            component='div'
            sx={{
                backgroundColor: '#4f758b',
                borderTop: '10px solid #496b80',
                zIndex: 0,
                padding: "50px 30px"
            }}
        >
            <Grid
                container
                sx={{
                    flexWrap: 'nowrap',
                    flexDirection: isMdUp ? 'row' : 'column'
                }}
            >
                {/* Logo and Address */}
                <Grid
                    sx={{
                        minWidth: '220px',
                        flexGrow: isMdUp ? 0 : 1
                    }}
                >
                    <LogoAddress />
                </Grid>

                {/* Center Links */}
                <Grid
                    sx={{
                        display: 'flex',
                        flexGrow: 1
                    }}
                >
                    <CenterLinks />
                </Grid>
            </Grid>
        </AppBar>
    );
};

export default Footer;
